import {
  FaBars,
  FaUserCircle,
  FaBell,
} from "react-icons/fa";

import {
  useState,
  useRef,
  useEffect,
} from "react";

import { useNavigate, } from "react-router-dom";
import { createPortal } from "react-dom";

import socket from "../../services/socket";
import API from "../../services/api";
import { hasPermission } from "../../utils/permission";

function AdminNavbar({
  setSidebarOpen,
}) {

  const navigate = useNavigate();

  const [open, setOpen] = useState(false);
  const dropdownRef = useRef();
  const [notifications, setNotifications] = useState([]);

  const [showNotif, setShowNotif] =
    useState(false);

  const notifRef = useRef();

  const soundRef = useRef(null);

  const admin =
    JSON.parse(
      localStorage.getItem(
        "admin"
      ) || "{}"
    );

  useEffect(() => {

    const handleClick = (e) => {

      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(
          e.target
        )
      ) {
        setOpen(false);
      }

      if (
        notifRef.current &&
        !notifRef.current.contains(
          e.target
        )
      ) {
        setShowNotif(false);
      }

    };

    document.addEventListener(
      "mousedown",
      handleClick
    );

    return () =>
      document.removeEventListener(
        "mousedown",
        handleClick
      );

  }, []);

  const logout = () => {

    localStorage.removeItem(
      "adminToken"
    );

    localStorage.removeItem(
      "admin"
    );

    navigate(
      "/admin/login"
    );
  };


  useEffect(() => {

    soundRef.current =
      new Audio(
        "/sounds/message.mp3"
      );

  }, []);

  useEffect(() => {

    if (
      typeof window !== "undefined" &&
      "Notification" in window
    ) {

      if (
        Notification.permission !== "granted"
      ) {

        Notification.requestPermission()
          .catch(() => { });

      }

    }

  }, []);

  useEffect(() => {

    const handleNotification =
      (data) => {

        if (
          typeof window !== "undefined" &&
          "Notification" in window &&
          Notification.permission === "granted"
        ) {

          new Notification(
            data.title,
            {
              body: data.message,
              icon: "/logo192.png",
            }
          );

        }

        if (soundRef.current) {

          soundRef.current.currentTime = 0;

          soundRef.current
            .play()
            .catch(() => { });

        }

        setNotifications(
          prev => [
            {
              ...data,
              is_read: 0,
            },
            ...prev,
          ]
        );
      };

    socket.on(
      "newNotification",
      handleNotification
    );

    return () => {

      socket.off(
        "newNotification",
        handleNotification
      );

    };

  }, []);

  useEffect(() => {
    loadLowStockAlerts();
  }, []);

  const loadLowStockAlerts =
    async () => {

      try {

        const res =
          await API.get(
            "/stock-alerts"
          );

        const alerts =
          res.data.map(
            product => ({
              title: "Low Stock Alert",
              message:
                `${product.name} stock is only ${product.stock}`
            })
          );

        setNotifications(
          alerts
        );

      } catch (err) {

        console.log(err);

      }

    };

  const unreadCount = notifications.length;


  return (
    <div
      className="
      h-20
      border-b
      border-yellow-500/20
      flex
      items-center
      justify-between
      px-4
      md:px-8
      bg-black/40
      backdrop-blur-xl
      no-print
      "
    >

      {/* LEFT */}

      <div
        className="
        flex
        items-center
        gap-4
        "
      >
        <button
          className="
          lg:hidden
          "
          onClick={() =>
            setSidebarOpen(
              true
            )
          }
        >
          <FaBars
            size={22}
          />
        </button>

        <h2
          className="
          text-lg
          md:text-xl
          font-bold
          "
        >
          {admin.name}
        </h2>
      </div>

      {/* RIGHT */}

      <div
        className="
  flex
  items-center
  gap-5
  "
      >
        <div
          className="relative"
          ref={notifRef}
        >
          <button
            onClick={() =>
              setShowNotif(
                !showNotif
              )
            }
            className="relative"
          >
            <FaBell
              size={22}
              className="
      text-yellow-400
      cursor-pointer
      "
            />

            {unreadCount > 0 && (
              <span
                className="
        absolute
        -top-2
        -right-2
        bg-red-500
        text-white
        text-[10px]
        w-5
        h-5
        rounded-full
        flex
        items-center
        justify-center
        "
              >
                {unreadCount}
              </span>
            )}
          </button>

          {showNotif &&
            createPortal(
              <div
                className="
        fixed
        top-20
        right-4
        md:right-8
        w-[320px]
        bg-[#111]
        border
        border-yellow-500/20
        rounded-2xl
        shadow-2xl
        z-[999999]
        overflow-hidden
        "
              >
                <div
                  className="
          p-4
          border-b
          border-yellow-500/20
          font-bold
          "
                >
                  Notifications
                </div>

                <div
                  className="
          max-h-[350px]
          overflow-y-auto
          "
                >
                  {notifications.length ? (
                    notifications.map(
                      (item, index) => (
                        <div
                          key={index}
                          className="
        p-4
        border-b
        border-yellow-500/10
        "
                        >
                          <div
                            className="
          text-red-400
          font-semibold
          "
                          >
                            {item.title}
                          </div>

                          <div
                            className="
          text-sm
          text-gray-300
          "
                          >
                            {item.message}
                          </div>
                        </div>
                      )
                    )
                  ) : (
                    <div
                      className="
    p-4
    text-center
    text-gray-500
    "
                    >
                      No Notifications
                    </div>
                  )}
                </div>
              </div>,
              document.body
            )}
        </div>

        <div
          className="
        relative
        "
          ref={dropdownRef}
        >

          <button
            onClick={() =>
              setOpen(
                !open
              )
            }
            className="
          flex
          items-center
          gap-3
          "
          >

            {
              admin?.profile_image ? (
                <img
                  src={`${process.env.REACT_APP_API_URL}/uploads/${admin.profile_image}`}
                  alt="Admin"
                  className="
      w-11
      h-11
      rounded-full
      object-cover
      border-2
      border-yellow-500
      "
                />
              ) : (
                <FaUserCircle
                  size={42}
                  className="
      text-yellow-400
      "
                />
              )
            }

            <div
              className="
            hidden
            md:block
            text-left
            "
            >
              <p
                className="
              font-semibold
              "
              >
                {admin?.name || "Admin"}
              </p>

              <p
                className="
              text-xs
              text-gray-400
              "
              >
                {admin?.role_name || "Administrator"}
              </p>
            </div>

          </button>

          {open && (
            <div
              className="
            absolute
            right-0
            mt-3
            w-60
            bg-[#111]
            border
            border-yellow-500/20
            rounded-2xl
            overflow-hidden
            shadow-2xl
            z-50
            "
            >

              {
                hasPermission("profile.view") && (
                  <button
                    onClick={() =>
                      navigate(
                        "/admin/profile"
                      )
                    }
                    className="
              w-full
              text-left
              px-5
              py-4
              hover:bg-yellow-500/10
              "
                  >
                    Update Profile
                  </button>
                )
              }

              {
                hasPermission("password.change") && (
                  <button
                    onClick={() =>
                      navigate(
                        "/admin/change-password"
                      )
                    }
                    className="
              w-full
              text-left
              px-5
              py-4
              hover:bg-yellow-500/10
              "
                  >
                    Change Password
                  </button>
                )}

              <button
                onClick={
                  logout
                }
                className="
              w-full
              text-left
              px-5
              py-4
              text-red-400
              hover:bg-red-500/10
              "
              >
                Logout
              </button>

            </div>
          )}

        </div>
      </div>

    </div>
  );
}

export default AdminNavbar;